module.exports = __webpack_public_path__ + "static/car2-e827be7def7c208065c809f669cb32cd.png";